import Link from 'next/link'
import React, { ReactElement } from 'react'

type LinkComponentProps = {
    url: string
    name: string
    wrapName?: boolean
}

export const LinkItem = ({
    url,
    name,
    wrapName = true
}: LinkComponentProps): ReactElement => {
    const content = wrapName ? <span>{name}</span> : name
    return <Link href={url}>{content}</Link>
}
